import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
/**
 * Body contract for updating a court system's vocabulary
 */
export class UpdateVocabularyBody {
    /**
     * @param courtSystemId The court system whose vocabulary to update
     * @param terms The new vocabulary terms for the court system
     */
    constructor(courtSystemId, terms) {
        this.terms = terms;
        this.courtSystemId = courtSystemId;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], UpdateVocabularyBody.prototype, "courtSystemId", void 0);
